import { IPendenciesRepository } from 'modules/customer/domain/repositories';
import { IVectisPendency, Pendency } from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export class VectisPendenciesRepository implements IPendenciesRepository {
  constructor(private httpProvider: IHTTPProvider) {}

  public findAll: IPendenciesRepository['findAll'] = async ({
    enterpriseId,
    customerId,
  }) => {
    const { contratos, nomeCliente } = await this.httpProvider.get<{
      contratos: IVectisPendency[];
      nomeCliente: string;
      valorTotalPendencias: number;
    }>(`/clientes/${customerId}/pendencias`, {
      params: { idEmpresa: enterpriseId },
    });

    return {
      customerName: nomeCliente,
      pendencies: contratos.map(contract => new Pendency(contract)),
    };
  };
}
